import { render, staticRenderFns } from "./TransactionComp.vue?vue&type=template&id=ec9e560c&scoped=true"
import script from "./TransactionComp.vue?vue&type=script&lang=js"
export * from "./TransactionComp.vue?vue&type=script&lang=js"
import style0 from "./TransactionComp.vue?vue&type=style&index=0&id=ec9e560c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9e560c",
  null
  
)

export default component.exports